module.exports = __webpack_public_path__ + "img/arrowLeft.6419b0d8.svg";